export default __webpack_public_path__ + "static/media/anchor_fill.00311a39.svg";